<template>
    <v-app>
        <appbar-view></appbar-view>

        <v-main>
            <v-container>

                <div class="userinfo">
                        
                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import AppbarView from '../appbar/appbarView.vue';
export default {
    name: "AjustesView",
    components: { AppbarView },
    data() {
        return {
            user: [],
            drawer: false,
        };
    },

    methods: {
        obtenerDatos() {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user) {
                this.user = user;
            }
        },
    },
    mounted() {
        this.obtenerDatos();
    },
};
</script>

<style>
.text-decoration-none {
    text-decoration: none;
}


.userinfo {
    text-align: center;

}
</style>